function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * @module ol/control/ScaleLine
 */
import Control from './Control.js';
import { CLASS_UNSELECTABLE } from '../css.js';
import { METERS_PER_UNIT, getPointResolution } from '../proj.js';

/**
 * @type {string}
 */
var UNITS_PROP = 'units';

/**
 * @typedef {'degrees' | 'imperial' | 'nautical' | 'metric' | 'us'} Units
 * Units for the scale line.
 */

/**
 * @const
 * @type {Array<number>}
 */
var LEADING_DIGITS = [1, 2, 5];

/**
 * @const
 * @type {number}
 */
var DEFAULT_DPI = 25.4 / 0.28;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:units', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |'change:units', Return>} ScaleLineOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {string} [className] CSS class name. The default is `ol-scale-bar` when configured with
 * `bar: true`. Otherwise the default is `ol-scale-line`.
 * @property {number} [minWidth=64] Minimum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {number} [maxWidth] Maximum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {Units} [units='metric'] Units.
 * @property {boolean} [bar=false] Render scalebars instead of a line.
 * @property {number} [steps=4] Number of steps the scalebar should use. Use even numbers
 * for best results. Only applies when `bar` is `true`.
 * @property {boolean} [text=false] Render the text scale above of the scalebar. Only applies
 * when `bar` is `true`.
 * @property {number|undefined} [dpi=undefined] dpi of output device such as printer. Only applies
 * when `bar` is `true`. If undefined the OGC default screen pixel size of 0.28mm will be assumed.
 */

/**
 * @classdesc
 * A control displaying rough y-axis distances, calculated for the center of the
 * viewport. For conformal projections (e.g. EPSG:3857, the default view
 * projection in OpenLayers), the scale is valid for all directions.
 * No scale line will be shown when the y-axis distance of a pixel at the
 * viewport center cannot be calculated in the view projection.
 * By default the scale line will show in the bottom left portion of the map,
 * but this can be changed by using the css selector `.ol-scale-line`.
 * When specifying `bar` as `true`, a scalebar will be rendered instead
 * of a scaleline.
 * For cartesian measurements of the scaleline, you need to set the
 * `getPointResolution` method of your projection to simply return the input
 * value, e.g. `projection.setGetPointResolution(r => r);`
 *
 * @api
 */
var ScaleLine = /*#__PURE__*/function (_Control) {
  /**
   * @param {Options} [options] Scale line options.
   */
  function ScaleLine(options) {
    var _this;
    _classCallCheck(this, ScaleLine);
    options = options ? options : {};
    var element = document.createElement('div');
    element.style.pointerEvents = 'none';
    _this = _callSuper(this, ScaleLine, [{
      element: element,
      render: options.render,
      target: options.target
    }]);

    /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */
    _this.on;

    /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */
    _this.once;

    /***
     * @type {ScaleLineOnSignature<void>}
     */
    _this.un;
    var className = options.className !== undefined ? options.className : options.bar ? 'ol-scale-bar' : 'ol-scale-line';

    /**
     * @private
     * @type {HTMLElement}
     */
    _this.innerElement_ = document.createElement('div');
    _this.innerElement_.className = className + '-inner';
    _this.element.className = className + ' ' + CLASS_UNSELECTABLE;
    _this.element.appendChild(_this.innerElement_);

    /**
     * @private
     * @type {?import("../View.js").State}
     */
    _this.viewState_ = null;

    /**
     * @private
     * @type {number}
     */
    _this.minWidth_ = options.minWidth !== undefined ? options.minWidth : 64;

    /**
     * @private
     * @type {number|undefined}
     */
    _this.maxWidth_ = options.maxWidth;

    /**
     * @private
     * @type {boolean}
     */
    _this.renderedVisible_ = false;

    /**
     * @private
     * @type {number|undefined}
     */
    _this.renderedWidth_ = undefined;

    /**
     * @private
     * @type {string}
     */
    _this.renderedHTML_ = '';
    _this.addChangeListener(UNITS_PROP, _this.handleUnitsChanged_);
    _this.setUnits(options.units || 'metric');

    /**
     * @private
     * @type {boolean}
     */
    _this.scaleBar_ = options.bar || false;

    /**
     * @private
     * @type {number}
     */
    _this.scaleBarSteps_ = options.steps || 4;

    /**
     * @private
     * @type {boolean}
     */
    _this.scaleBarText_ = options.text || false;

    /**
     * @private
     * @type {number|undefined}
     */
    _this.dpi_ = options.dpi || undefined;
    return _this;
  }

  /**
   * Return the units to use in the scale line.
   * @return {Units} The units
   * to use in the scale line.
   * @observable
   * @api
   */
  _inherits(ScaleLine, _Control);
  return _createClass(ScaleLine, [{
    key: "getUnits",
    value: function getUnits() {
      return this.get(UNITS_PROP);
    }

    /**
     * @private
     */
  }, {
    key: "handleUnitsChanged_",
    value: function handleUnitsChanged_() {
      this.updateElement_();
    }

    /**
     * Set the units to use in the scale line.
     * @param {Units} units The units to use in the scale line.
     * @observable
     * @api
     */
  }, {
    key: "setUnits",
    value: function setUnits(units) {
      this.set(UNITS_PROP, units);
    }

    /**
     * Specify the dpi of output device such as printer.
     * @param {number|undefined} dpi The dpi of output device.
     * @api
     */
  }, {
    key: "setDpi",
    value: function setDpi(dpi) {
      this.dpi_ = dpi;
    }

    /**
     * @private
     */
  }, {
    key: "updateElement_",
    value: function updateElement_() {
      var viewState = this.viewState_;
      if (!viewState) {
        if (this.renderedVisible_) {
          this.element.style.display = 'none';
          this.renderedVisible_ = false;
        }
        return;
      }
      var center = viewState.center;
      var projection = viewState.projection;
      var units = this.getUnits();
      var pointResolutionUnits = units == 'degrees' ? 'degrees' : 'm';
      var pointResolution = getPointResolution(projection, viewState.resolution, center, pointResolutionUnits);
      var minWidth = this.minWidth_ * (this.dpi_ || DEFAULT_DPI) / DEFAULT_DPI;
      var maxWidth = this.maxWidth_ !== undefined ? this.maxWidth_ * (this.dpi_ || DEFAULT_DPI) / DEFAULT_DPI : undefined;
      var nominalCount = minWidth * pointResolution;
      var suffix = '';
      if (units == 'degrees') {
        var metersPerDegree = METERS_PER_UNIT.degrees;
        nominalCount *= metersPerDegree;
        if (nominalCount < metersPerDegree / 60) {
          suffix = "\u2033"; // seconds
          pointResolution *= 3600;
        } else if (nominalCount < metersPerDegree) {
          suffix = "\u2032"; // minutes
          pointResolution *= 60;
        } else {
          suffix = "\xB0"; // degrees
        }
      } else if (units == 'imperial') {
        if (nominalCount < 0.9144) {
          suffix = 'in';
          pointResolution /= 0.0254;
        } else if (nominalCount < 1609.344) {
          suffix = 'ft';
          pointResolution /= 0.3048;
        } else {
          suffix = 'mi';
          pointResolution /= 1609.344;
        }
      } else if (units == 'nautical') {
        pointResolution /= 1852;
        suffix = 'NM';
      } else if (units == 'metric') {
        if (nominalCount < 1e-6) {
          suffix = 'nm';
          pointResolution *= 1e9;
        } else if (nominalCount < 0.001) {
          suffix = 'μm';
          pointResolution *= 1000000;
        } else if (nominalCount < 1) {
          suffix = 'mm';
          pointResolution *= 1000;
        } else if (nominalCount < 1000) {
          suffix = 'm';
        } else {
          suffix = 'km';
          pointResolution /= 1000;
        }
      } else if (units == 'us') {
        if (nominalCount < 0.9144) {
          suffix = 'in';
          pointResolution *= 39.37;
        } else if (nominalCount < 1609.344) {
          suffix = 'ft';
          pointResolution /= 0.30480061;
        } else {
          suffix = 'mi';
          pointResolution /= 1609.3472;
        }
      } else {
        throw new Error('Invalid units');
      }
      var i = 3 * Math.floor(Math.log(minWidth * pointResolution) / Math.log(10));
      var count, width, decimalCount;
      var previousCount, previousWidth, previousDecimalCount;
      while (true) {
        decimalCount = Math.floor(i / 3);
        var decimal = Math.pow(10, decimalCount);
        count = LEADING_DIGITS[(i % 3 + 3) % 3] * decimal;
        width = Math.round(count / pointResolution);
        if (isNaN(width)) {
          this.element.style.display = 'none';
          this.renderedVisible_ = false;
          return;
        }
        if (maxWidth !== undefined && width >= maxWidth) {
          count = previousCount;
          width = previousWidth;
          decimalCount = previousDecimalCount;
          break;
        } else if (width >= minWidth) {
          break;
        }
        previousCount = count;
        previousWidth = width;
        previousDecimalCount = decimalCount;
        ++i;
      }
      var html = this.scaleBar_ ? this.createScaleBar(width, count, suffix) : count.toFixed(decimalCount < 0 ? -decimalCount : 0) + ' ' + suffix;
      if (this.renderedHTML_ != html) {
        this.innerElement_.innerHTML = html;
        this.renderedHTML_ = html;
      }
      if (this.renderedWidth_ != width) {
        this.innerElement_.style.width = width + 'px';
        this.renderedWidth_ = width;
      }
      if (!this.renderedVisible_) {
        this.element.style.display = '';
        this.renderedVisible_ = true;
      }
    }

    /**
     * @private
     * @param {number} width The current width of the scalebar.
     * @param {number} scale The current scale.
     * @param {string} suffix The suffix to append to the scale text.
     * @return {string} The stringified HTML of the scalebar.
     */
  }, {
    key: "createScaleBar",
    value: function createScaleBar(width, scale, suffix) {
      var resolutionScale = this.getScaleForResolution();
      var mapScale = resolutionScale < 1 ? Math.round(1 / resolutionScale).toLocaleString() + ' : 1' : '1 : ' + Math.round(resolutionScale).toLocaleString();
      var steps = this.scaleBarSteps_;
      var stepWidth = width / steps;
      var scaleSteps = [this.createMarker('absolute')];
      for (var i = 0; i < steps; ++i) {
        var cls = i % 2 === 0 ? 'ol-scale-singlebar-odd' : 'ol-scale-singlebar-even';
        scaleSteps.push('<div>' + '<div ' + "class=\"ol-scale-singlebar ".concat(cls, "\" ") + "style=\"width: ".concat(stepWidth, "px;\"") + '>' + '</div>' + this.createMarker('relative') + (
        // render text every second step, except when only 2 steps
        i % 2 === 0 || steps === 2 ? this.createStepText(i, width, false, scale, suffix) : '') + '</div>');
      }
      // render text at the end
      scaleSteps.push(this.createStepText(steps, width, true, scale, suffix));
      var scaleBarText = this.scaleBarText_ ? "<div class=\"ol-scale-text\" style=\"width: ".concat(width, "px;\">") + mapScale + '</div>' : '';
      return scaleBarText + scaleSteps.join('');
    }

    /**
     * Creates a marker at given position
     * @param {'absolute'|'relative'} position The position, absolute or relative
     * @return {string} The stringified div containing the marker
     */
  }, {
    key: "createMarker",
    value: function createMarker(position) {
      var top = position === 'absolute' ? 3 : -10;
      return '<div ' + 'class="ol-scale-step-marker" ' + "style=\"position: ".concat(position, "; top: ").concat(top, "px;\"") + '></div>';
    }

    /**
     * Creates the label for a marker marker at given position
     * @param {number} i The iterator
     * @param {number} width The width the scalebar will currently use
     * @param {boolean} isLast Flag indicating if we add the last step text
     * @param {number} scale The current scale for the whole scalebar
     * @param {string} suffix The suffix for the scale
     * @return {string} The stringified div containing the step text
     */
  }, {
    key: "createStepText",
    value: function createStepText(i, width, isLast, scale, suffix) {
      var length = i === 0 ? 0 : Math.round(scale / this.scaleBarSteps_ * i * 100) / 100;
      var lengthString = length + (i === 0 ? '' : ' ' + suffix);
      var margin = i === 0 ? -3 : width / this.scaleBarSteps_ * -1;
      var minWidth = i === 0 ? 0 : width / this.scaleBarSteps_ * 2;
      return '<div ' + 'class="ol-scale-step-text" ' + 'style="' + "margin-left: ".concat(margin, "px;") + "text-align: ".concat(i === 0 ? 'left' : 'center', ";") + "min-width: ".concat(minWidth, "px;") + "left: ".concat(isLast ? width + 'px' : 'unset', ";") + '">' + lengthString + '</div>';
    }

    /**
     * Returns the appropriate scale for the given resolution and units.
     * @return {number} The appropriate scale.
     */
  }, {
    key: "getScaleForResolution",
    value: function getScaleForResolution() {
      var resolution = getPointResolution(this.viewState_.projection, this.viewState_.resolution, this.viewState_.center, 'm');
      var dpi = this.dpi_ || DEFAULT_DPI;
      var inchesPerMeter = 1000 / 25.4;
      return resolution * inchesPerMeter * dpi;
    }

    /**
     * Update the scale line element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */
  }, {
    key: "render",
    value: function render(mapEvent) {
      var frameState = mapEvent.frameState;
      if (!frameState) {
        this.viewState_ = null;
      } else {
        this.viewState_ = frameState.viewState;
      }
      this.updateElement_();
    }
  }]);
}(Control);
export default ScaleLine;